import useDefinedContext from "hooks/useDefinedContext";
import { OnBoardingContext } from "../OnBoardingProvider";

interface UseOnBoardingProps {}

function useOnBoarding(props?: UseOnBoardingProps) {
  return useDefinedContext(OnBoardingContext);
}

export default useOnBoarding;
